import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { socket } from 'api';
import { playSound, stopSound } from 'store/actions/sounds';
import { dropCall } from 'store/actions/calls';
import { Content, ButtonBlock, CallBlock, CallIcon, CallIndicator } from './RackCall.styled';

let closeTimeout = null;

export const RackCall = ({ info }) => {
  // console.log('🚀 ~ RackCall ~ info:', info);
  const { status, source_inner_id } = info;

  // const isSoundPlay = useSelector((store) => !!store.sounds.sounds['call']);
  const isActiveCallExist = useSelector((store) => store.widgets.activeWidgets.indexOf('activeCall') >= 0);

  const [callBlock, setCallBlock] = useState(false);
  const dispatch = useDispatch();

  // start/stop sound
  useEffect(() => {
    if (status === 'wait' /*&& !isActiveCallExist && !isSoundPlay*/) {
      // console.log('🚀 ~ play soynd:');
      dispatch(playSound('call'));
    } else {
      // if (isActiveCallExist || status !== 'wait') {
        dispatch(stopSound('call'));
      // }
    }

    return () => {
      // console.log('rackCall effect exit')
      // dispatch(stopSound('call'));
    };
  }, [status/*, isActiveCallExist, isSoundPlay*/]);

  /**
   * show block
   */
  const showCallBlock = () => {
    if (closeTimeout) {
      clearTimeout(closeTimeout);
    }
    setCallBlock(true);
  };

  /**
   * hide block
   */
  const hideCallBlock = () => {
    closeTimeout = setTimeout(() => {
      setCallBlock(false);
    }, 100);
  };

  /**
   * answer
   */
  const makeAnswerRequest = () => {
    if (isActiveCallExist) {
      return;
    }
    dispatch(stopSound('call'));
    socket.call('call_answer', info);
    window.addActiveCall(source_inner_id);
  };

  /**
   * cancel call
   */
  const cancelCall = () => {
    if (isActiveCallExist) {
      socket.call('call_end', {
        id: info.id,
        target: source_inner_id,
      });
    } else {
      socket.call('call_reject', {
        id: info.id,
        source: source_inner_id,
      });
    }
    dispatch(stopSound('call'));
    dispatch(dropCall(source_inner_id));
  };

  // render
  return (
    <Content onMouseEnter={showCallBlock} onMouseLeave={hideCallBlock}>
      {callBlock && status === 'wait' && (
        <CallBlock>
          <ButtonBlock>
            <img onClick={makeAnswerRequest} src="/images/audio.png" alt="" />
            <span>Ответить</span>
          </ButtonBlock>
          <ButtonBlock>
            <img onClick={cancelCall} src="/images/audio-2.png" alt="" />
            <span>Отклонить</span>
          </ButtonBlock>
        </CallBlock>
      )}
      <CallIcon status={status} src="/images/call.png" />
      {status === 'active' && <CallIndicator />}
    </Content>
  );
};
